import React from 'react';
import dayjs from 'dayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Select, MenuItem, TextField, InputLabel, FormControl, FormHelperText } from '@mui/material';

const Inputs = ({
    type,
    label,
    value = '',
    onChange,
    required = false,
    rows = 1,
    mt = 2,
    mb = 2,
    disablePast = false,
    disableFuture = false,
    format = "dddd DD/MM/YYYY, HH:mm",
    views = ['day', 'hours', 'minutes'],
    possibilities = [],
    error = false,
    helperText = '',
    disabled = false
}) => (
    type === 'text' ? (
        <TextField
            label={label}
            value={value}
            onChange={onChange}
            required={required}
            rows={rows}
            multiline={rows > 1}
            fullWidth
            sx={{ mt: mt, mb: rows > 1 ? 0 : mb }}
            margin="normal"
            variant="outlined"
            error={error}
            helperText={helperText}
            disabled={disabled}
        />
    ) : type === 'date' ? (
        <DateTimePicker
            label={label}
            disablePast={disablePast}
            disableFuture={disableFuture}
            minutesStep={format === "dddd DD/MM/YYYY, HH:mm" ? 15 : 0}
            ampm={false}
            required={required}
            sx={{
                width: '100%',
                mt: mt
            }}
            value={dayjs(value)}
            onChange={onChange}
            format={format}
            views={views}
            disabled={disabled}
            slotProps={{
                textField: {
                    error: error,
                    helperText: helperText,
                    disabled: disabled,
                },
            }}
        />
    ) : type === 'select' ? (
        <FormControl fullWidth sx={{ mt: mt, minWidth: 0 }}>
            <InputLabel id={`${label}-label`}>{label}</InputLabel>
            <Select
                labelId={`${label}-label`}
                value={value || possibilities[0]?.value || ''}
                onChange={onChange}
                label={label}
                hiddenlabel="false"
                required={required}
                error={error}
                disabled={disabled}
            >
                {helperText && (
                    <FormHelperText error={error}>
                        {helperText}
                    </FormHelperText>
                )}
                {possibilities.map((item, index) => (
                    <MenuItem
                        key={index}
                        value={item.value}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    ) : null
);

export default Inputs;
